import { render, staticRenderFns } from "./InvoiceCategorization.vue?vue&type=template&id=6615f245&"
import script from "./InvoiceCategorization.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCategorization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports